'use strict';

(function () {

  angular
    .module('specsguardApp')
    .component('sgProjectSettings', {
      bindings: {
        project: '<',
        updateProject: '&'
      },
      templateUrl: 'app-legacy/project/administration/project.settings.html',
      controller: 'ProjectSettingsCtrl',
      controllerAs: '$ProjectSettingsCtrl',
    });

})();
